import { Texture, Rectangle, Sprite, utils } from "pixi.js";
import { Carousel, InteractionEvents, UserAgent } from "@cc/pixi-app";
import { ScreenBase } from "./ScreenBase";
import { Photo } from "./../common/Photo";
import { ButtonBase } from "./../common/ButtonBase";
import { avatarGenerator } from "./../common/AvatarGenerator";
import { storageManager } from "./../common/StorageManager";
import { dataImporter } from "./../DataImporter";
import { CarouselEvents } from "../../../node_modules/@cc/pixi-app/dist/carousel/CarouselEvents";
import { app } from "../app";
import { PhotoOverlay } from "./../utils/PhotoOverlay";

export class ScreenPhotoGallery extends ScreenBase {
    init() {
        this.packData = dataImporter.currPack;
        this.ui.addChild(this.createMuteButton("TopRight"));

        this.background = new Sprite.from(dataImporter.currPack.photoGallery.bg);
        this.background.anchor.set(0.5);
        this.background.height = this.app.resizer.height;
        this.background.scale.x = this.background.scale.y;
        this.addChild(this.background);

        this.backing = new Sprite.from(dataImporter.currPack.photoGallery.backing);
        this.backing.anchor.set(0.5);
        this.addChild(this.backing);

        this.pageL = new Sprite.from(dataImporter.currPack.photoGallery.pageL);
        this.pageL.anchor.set(1, 0.5);
        //this.pageL.scale.set(-1, 1);
        this.pageL.x = -this.pageL.width * 0.5;
        this.addChild(this.pageL);

        this.pageR = new Sprite.from(dataImporter.currPack.photoGallery.pageR);
        this.pageR.anchor.set(0.5);
        this.pageR.scale.set(-1, 1);
        this.pageR.x = this.pageL.width * 0.5;
        this.pageL.addChild(this.pageR);

        this.photos = this.createPhotos();
        this.photoOverlay = new PhotoOverlay();

        this.downloadButton = new ButtonBase(new Texture.from("download-btn"));
        this.downloadButton.position.set(400, 500);
        this.downloadButton.on(InteractionEvents.PointerTap, () => {
            let base64 = app.renderer.plugins.extract.base64(
                this.photos[this.carousel.index],
                "image/png"
            );

            if (utils.isMobile.apple.device || UserAgent.isIe) {
                this.photoOverlay.show(base64);
            } else {
                let downloadLink = document.createElement("a");
                document.body.appendChild(downloadLink);
                downloadLink.download = "photo.png";
                downloadLink.href = base64;
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
        });

        this.tickButton = new ButtonBase(new Texture.from("tick-btn"));
        this.tickButton.position.set(700, 500);
        this.tickButton.on(
            InteractionEvents.PointerTap,
            () => {
                this.app.sound.play("02-ui-click");
                this.exit();
            },
            this
        );

        this.nextButton = new ButtonBase(new Texture.from("right-avatar-select"));
        this.nextButton.anchor.set(1, 0.5);
        this.prevButton = new ButtonBase(new Texture.from("left-avatar-select"));
        this.prevButton.anchor.set(0, 0.5);

        this.carousel = new Carousel({
            animateScale: false,
            animateAlpha: false,
            draggable: false,
            spacing: this.app.resizer.width * 1.5,
            arrowNext: this.nextButton,
            arrowPrevious: this.prevButton,
            items: this.photos,
            hitArea: new Rectangle(-250, -250, 500, 500)
        });
        this.carousel.on(CarouselEvents.SetIndex, () => {
            this.app.sound.play("03-ui-swipe-photo-album");
            this.moveAvatar();
        });

        this.animateCarousel();

        this.prevButton.x = -(this.app.resizer.width / 2);
        this.nextButton.x = this.app.resizer.width / 2;
        this.addChild(this.nextButton);
        this.addChild(this.prevButton);
        this.addChild(this.carousel);
        this.addChild(this.downloadButton);
        this.addChild(this.tickButton);

        this.createAvatar();
    }

    createAvatar() {
        this.avatar = avatarGenerator.getAnimation("avatar-front-anim", "front", false);
        this.addChild(this.avatar);
        this.moveAvatar();
        this.avatar.setAnimation(0, "idle", false);
        this.avatar.timeScale = 0;
        this.avatar.spine.state.tracks[0].trackTime = 0;
    }

    createPhotos() {
        let photoData = dataImporter.currPack.photoGallery.photos;
        let photos = [];

        Object.keys(photoData).forEach(key => {
            if (storageManager.completeMissions[dataImporter.currPack.id].includes(key) === true) {
                photos.push(new Photo(photoData[key]));
            }
        });

        return photos;
    }

    moveAvatar() {
        this.photos[this.carousel.index].positionAvatar(this.avatar);
    }

    animateCarousel() {
        for (var i = 0; i <= this.carousel.children.length - 1; i++) {
            let int = i;
            this.wait((this.carousel.children.length + int) * 650).call(() =>
                this.carousel.setIndex(int)
            );
        }
    }

    exit() {
        if (document.getElementById('photo-overlay')) document.getElementById('photo-overlay').remove();
        this.app.showScreen("missionSelect", dataImporter.currPack.tags.missionSelect);
    }
}
